<div
  *ngIf="!is_list_running"
  class="sp-width__full sp-min-height__full sp-column">
  <app-company-details-pending-invitations-data-table
    *ngIf="invitations?.length"
    [invitations]="invitations || []"
    class="sp-width__full"></app-company-details-pending-invitations-data-table>
</div>

<app-loading *ngIf="is_list_running"> </app-loading>
